import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["articles", "imageType", "knowledgeCategoryId"],
  _excluded2 = ["articles", "color", "icon", "imageType"],
  _excluded3 = ["articleIds", "categoryId", "color", "icon", "imageTypeEnum"];
import { List, Record } from 'immutable';
import { IMAGE_TYPES } from '../constants/templateEditor/HomepageOrganizationConstants';
// @bend-expect trellis-skip-migration
const DEFAULT_HOMEPAGE_CATEGORY_COLOR = '#7c98b6';
class HomepageCategory extends Record({
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  articles: new List(),
  color: DEFAULT_HOMEPAGE_CATEGORY_COLOR,
  icon: undefined,
  iconSvg: undefined,
  // TODO @sstamenov delete this when it's removed from the BE object
  imageSrc: undefined,
  imageType: IMAGE_TYPES.ICON,
  isDisplayed: false,
  knowledgeCategoryId: undefined
}) {
  toKnowledgeHomepageCategoryJS() {
    const _Record$prototype$toJ = Record.prototype.toJS.apply(this),
      {
        articles,
        imageType,
        knowledgeCategoryId
      } = _Record$prototype$toJ,
      rest = _objectWithoutPropertiesLoose(_Record$prototype$toJ, _excluded);
    return Object.assign({}, rest, {
      articleIds: articles,
      categoryId: knowledgeCategoryId,
      imageTypeEnum: imageType
    });
  }
}
HomepageCategory.fromJS = _ref => {
  let {
      articles = [],
      color,
      icon,
      imageType
    } = _ref,
    json = _objectWithoutPropertiesLoose(_ref, _excluded2);
  return new HomepageCategory(json).merge({
    articles,
    color: color || DEFAULT_HOMEPAGE_CATEGORY_COLOR,
    icon,
    imageType: imageType || IMAGE_TYPES.ICON
  });
};
HomepageCategory.fromKnowledgeHomepageCategoryJS = _ref2 => {
  let {
      articleIds = [],
      categoryId,
      color,
      icon,
      imageTypeEnum
    } = _ref2,
    json = _objectWithoutPropertiesLoose(_ref2, _excluded3);
  return new HomepageCategory(json).merge({
    articles: articleIds,
    color: color || DEFAULT_HOMEPAGE_CATEGORY_COLOR,
    icon,
    imageType: imageTypeEnum || IMAGE_TYPES.ICON,
    knowledgeCategoryId: categoryId
  });
};
export default HomepageCategory;